'use strict';

angular.module('searchModule')

.controller('RefineFacetGroupControlStatusController', ['$scope', function ($scope) {

    var controlStatusFacetGroups = [{
        value: 'PendingInformation',
        ControlStatusCssLabel: 'label label-gray',
        ControlStatusCssIcon: 'fa fa-flag',
        ColumnValue: 'Pending Information',
    }, {
        value: 'ReadyForTesting',
        ControlStatusCssLabel: 'label label-blue',
        ControlStatusCssIcon: 'fa fa-pencil-square-o',
        ColumnValue: 'Ready For Testing'
    }, {
        value: 'TestingInProgress',
        ControlStatusCssLabel: 'label label-cyan',
        ControlStatusCssIcon: 'fa fa-clock-o',
        ColumnValue: 'Testing In Progress'
    }, {
        value: 'ControlTestingToReview',
        ControlStatusCssLabel: 'label label-warning',
        ControlStatusCssIcon: 'fa fa-clock-o',
        ColumnValue: 'Control Testing To Review'
    }, {
        value: 'ReadyForCertification',
        ControlStatusCssLabel: 'label label-gold',
        ControlStatusCssIcon: 'fa fa-certificate',
        ColumnValue: 'Ready For Certification'
    }, {
        value: 'CertificationInProgress',
        ControlStatusCssLabel: 'label label-red',
        ControlStatusCssIcon: 'fa fa-clock-o',
        ColumnValue: 'Certification In Progress'
    }, {
        value: 'CertificationToReview',
        ControlStatusCssLabel: 'label label-purple',
        ControlStatusCssIcon: 'fa fa-clock-o',
        ColumnValue: 'Certification To Review'
    }, {
        value: 'Completed',
        ControlStatusCssLabel: 'label label-green',
        ControlStatusCssIcon: 'fa fa-check-square-o',
        ColumnValue: 'Completed'
    }];

    // Remap controlStatusFacetGroups with Control Assessment
    $scope.refineFacetsById.RefineFacetsByColumnValue =
                                      _.chain(controlStatusFacetGroups)
                                       .map(function (group) {
                                           var foundRefineFacetGroup = _.find($scope.refineFacetsById.RefineFacetsByColumnValue, { ColumnValue: group.ColumnValue })

                                           if (!foundRefineFacetGroup) {
                                               foundRefineFacetGroup = group;
                                               foundRefineFacetGroup.RefineFacetsCount = 0;
                                           }

                                           return _.assign(group, foundRefineFacetGroup);
                                       })
                                        .value();
    $scope.refineFacetsById.DisplayedRefineFacetsByColumnValue = $scope.refineFacetsById.RefineFacetsByColumnValue;

    $scope.toggleControlStatusRefineFacetGroupSelection = function (refineFacetsByColumnValue) {
        if (refineFacetsByColumnValue.RefineFacetsCount === 0) return;

        $scope.toggleRefineFacetSelection(refineFacetsByColumnValue.RefineFacetID, refineFacetsByColumnValue.ColumnValue);
    };

    $scope.getCssClassesForFacetGroup = function (facetGroup) {
        if (facetGroup.RefineFacetsCount > 0) return 'u-pointer';

        return 'u-pointer-normal';
    };

}]);